import script from "./store_component.vue?vue&type=script&setup=true&lang=js"
export * from "./store_component.vue?vue&type=script&setup=true&lang=js"

import "./store_component.vue?vue&type=style&index=0&id=13a3d10f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13a3d10f"]])

export default __exports__